import React, { useCallback, useEffect, useState } from 'react';

type Iprops = {
  checked?: boolean
  label?: any
  disable?: boolean
  onChange?: (flag?: boolean) => void
  className?: string
}

function Checked(props: Iprops) {

  const {
    checked,
    label,
    disable,
    onChange,
    className
  } = props
  let [value, setVal] = useState(false)

  const onchange = useCallback(() => {
    if (disable) return
    setVal(!value)
    onChange && onChange(!value)
  }, [value, disable, setVal, onChange])

  useEffect(() => {
    setVal(!!checked)
  }, [checked])

  return (
    <div className={`flex justify-center items-center ${disable ? ' cursor-not-allowed' : ' cursor-pointer'}`} onClick={onchange} >
      <div className=' h-[16px]'>
        {
          disable ? <img alt='disable' className=' h-[16px]' src={require('../../../img/disablecheck@3.png')} />
          : value ? <img alt='checked' className=' h-[16px]' src={require('../../../img/checked@3.png')} />
          : <img alt='unchecked' className=' h-[16px]' src={require('../../../img/unchecked@3.png')} />
        }
      </div>
      {
        label ?
        <div className={` ml-2 ${className} ${disable ? ' opacity-60' : ''}`}>
          {label}
        </div> : ''
      }
    </div>
  );
}

export default Checked;
